import { Exception } from '@web/common';

export class ControlReferenceNotFoundException extends Exception {
  public constructor(
    message = 'The reference to "FormControl" was not found.',
  ) {
    super(message);
  }
}
